import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { RubroSelect } from "@/components/RubroSelect";

// Profile rubro: saves on select (or on blur of the detail when "Otro").
export const EmpresaRubro = ({ empresa, rubros, otro, onSaved }) => {
  const [v, setV] = useState({ rubro: empresa.rubro || "", rubro_detalle: empresa.rubro_detalle || "" });
  const save = (body) => api.put("/empresa/profile", body).then((r) => { toast.success("Guardado"); onSaved?.(r.data); })
    .catch((e) => toast.error(e.response?.data?.detail || "No se pudo guardar"));
  const change = (nv) => {
    setV(nv);
    if (nv.rubro && nv.rubro !== otro && nv.rubro !== v.rubro) save({ rubro: nv.rubro });
  };
  const blur = () => { if (v.rubro_detalle.trim()) save(v); };
  return <RubroSelect rubros={rubros} otro={otro} value={v.rubro} detalle={v.rubro_detalle} onChange={change} onDetalleBlur={blur} testid="emp-rubro" />;
};
